// sidebarData.js
import AdminDashboard from '../../../feature-module/mainMenu/adminDashboard';
import { all_routes } from '../../../feature-module/router/all_routes';
const routes = all_routes;

export const SidebarData = [
  {
    label: 'Main',
    submenuOpen: false,
    showSubRoute: false,
    submenuHdr: 'Main',
    icon: 'ti ti-home',
    submenuItems: [
      {
        icon: 'ti ti-home-2',
        label: 'Home',
        path: '/',
        submenu: false,
        showSubRoute: false,
      },
      {
        icon: 'ti ti-chess-knight',
        label: 'About Us',
        path: '/about-us',
        submenu: false,
        showSubRoute: false,
      },
      {
        icon: 'ti ti-ball-basketball',
        label: 'Our Team',
        path: '/our-team',
        submenu: false,
        showSubRoute: false,
      },
      {
        icon: 'ti ti-mail',
        label: 'Contact Us',
        path: '/contact-us',
        submenu: false,
        showSubRoute: false,
      },
    ],
  },
  {
    label: 'Dashboard',
    submenuOpen: false,
    showSubRoute: false,
    submenuHdr: 'Dashboard',
    icon: 'ti ti-dashboard',
    submenuItems: [
      {
        label: 'Dashboard',
        icon: 'ti ti-dashboard',
        submenu: false,
        showSubRoute: false,
        link: routes.adminDashboard,
        roles: ['admin'],
      },
      {
        label: 'Dashboard',
        icon: 'ti ti-dashboard',
        submenu: false,
        showSubRoute: false,
        link: routes.coachDashboard,
        roles: ['coach'],
      },
      {
        label: 'AI Email Assistant',
        icon: 'ti ti-sparkles',
        submenu: false,
        showSubRoute: false,
        link: routes.aiEmailAssistant,
        roles: ['admin'],
      },
    ],
  },
  {
    label: 'Team',
    submenuOpen: false,
    showSubRoute: false,
    submenuHdr: 'Peoples',
    icon: 'ti ti-users',
    submenuItems: [
      {
        label: 'Players',
        icon: 'ti ti-shirt-sport',
        submenu: false,
        showSubRoute: false,
        link: routes.PlayerList,
        roles: ['admin', 'coach', 'user'],
      },
      {
        label: 'Parents',
        icon: 'ti ti-users',
        submenu: false,
        roles: ['admin', 'coach', 'user'],
      },
      {
        label: 'Coaches',
        icon: 'ti ti-user-bolt',
        submenu: false,
        showSubRoute: false,
        link: routes.coachList,
        roles: ['admin'],
      },
    ],
  },
  {
    label: 'Tournaments',
    submenuOpen: false,
    showSubRoute: false,
    submenuHdr: 'Tournaments',
    icon: 'ti ti-trophy',
    submenuItems: [
      {
        label: 'Tournaments',
        icon: 'ti ti-shield',
        submenu: false,
        showSubRoute: false,
        link: routes.tournamentAdminPage,
        roles: ['admin'],
      },
      {
        label: 'Tournament',
        icon: 'ti ti-tournament',
        submenu: false,
        showSubRoute: false,
        link: routes.adminTournaments,
        roles: ['admin', 'coach'],
      },
    ],
  },
  {
    label: 'Managers',
    submenuOpen: false,
    showSubRoute: false,
    submenuHdr: 'Peoples',
    icon: 'ti ti-users',
    submenuItems: [
      {
        label: 'Teams',
        icon: 'ti ti-trophy',
        submenu: false,
        showSubRoute: false,
        link: routes.teams,
        roles: ['admin', 'coach'],
      },
      {
        label: 'Forms',
        submenu: false,
        showSubRoute: false,
        link: routes.formBuilder,
        icon: 'ti ti-checkup-list',
        roles: ['admin'],
      },
    ],
  },
  {
    label: 'Schedule/Events',
    submenuOpen: false,
    showSubRoute: false,
    submenuHdr: 'Schedule/Events',
    icon: 'ti ti-calendar',
    submenuItems: [
      {
        label: 'Schedule',
        icon: 'ti ti-calendar-event',
        submenu: false,
        showSubRoute: false,
        link: routes.events,
        roles: ['admin', 'coach'],
      },
    ],
  },
  {
    label: 'Email',
    submenuOpen: false,
    showSubRoute: false,
    submenuHdr: 'Email',
    icon: 'ti ti-mail',
    submenuItems: [
      {
        label: 'Templates',
        submenu: false,
        showSubRoute: false,
        link: routes.emailTemplates,
        icon: 'ti ti-file-symlink',
        roles: ['admin'],
      },
      {
        label: 'Template Builder',
        submenu: false,
        showSubRoute: false,
        link: routes.emailTemplatesBuilder,
        icon: 'ti ti-layout-grid-add',
        roles: ['admin'],
      },
      {
        label: 'Send Email',
        submenu: false,
        showSubRoute: false,
        link: routes.EmailTemplateSelector,
        icon: 'ti ti-mail-forward',
        roles: ['admin'],
      },
    ],
  },
  {
    label: 'Pages',
    submenuOpen: false,
    showSubRoute: false,
    submenuHdr: 'Pages',
    icon: 'ti ti-file-text',
    submenuItems: [
      {
        label: 'All Pages',
        submenu: false,
        showSubRoute: false,
        link: '/admin/pages',
        icon: 'ti ti-file-text',
        roles: ['admin'],
      },
      {
        label: 'Page Builder',
        submenu: false,
        showSubRoute: false,
        link: '/admin/page-builder',
        icon: 'ti ti-layout-dashboard',
        roles: ['admin'],
      },
      {
        label: 'In the Spotlight',
        submenu: false,
        showSubRoute: false,
        link: routes.spotlightManager,
        icon: 'ti ti-star',
        roles: ['admin'],
      },
    ],
  },
  {
    label: 'Registration',
    submenuOpen: false,
    showSubRoute: false,
    submenuHdr: 'Registration Management',
    icon: 'ti ti-forms',
    submenuItems: [
      {
        label: 'Registrations Manager',
        submenu: false,
        showSubRoute: false,
        link: routes.adminRegistrationManager,
        icon: 'ti ti-forms',
        roles: ['admin'],
      },
      {
        label: 'Season Events',
        submenu: false,
        showSubRoute: false,
        link: routes.adminSeasonEvents,
        icon: 'ti ti-calendar',
        roles: ['admin'],
      },
      {
        label: 'Event Configurations',
        submenuOpen: false,
        showSubRoute: false,
        submenuHdr: 'Event Configs',
        icon: 'ti ti-settings',
        submenuItems: [
          {
            label: 'Tryouts',
            icon: 'ti ti-target-arrow',
            submenu: false,
            showSubRoute: false,
            link: '/admin/tryout-config',
            roles: ['admin'],
          },
          {
            label: 'Training',
            icon: 'ti ti-ball-basketball',
            submenu: false,
            showSubRoute: false,
            link: '/admin/training-config',
            roles: ['admin'],
          },
          {
            label: 'Tournaments',
            icon: 'ti ti-trophy',
            submenu: false,
            showSubRoute: false,
            link: '/admin/tournament-config',
            roles: ['admin'],
          },
        ],
      },
      {
        label: 'Form Fields',
        submenu: false,
        showSubRoute: false,
        link: routes.adminFormConfigs,
        icon: 'ti ti-settings-cog',
        roles: ['admin'],
      },
    ],
  },
  {
    label: 'Finance',
    submenuOpen: false,
    showSubRoute: false,
    submenuHdr: 'Finance',
    icon: 'ti ti-currency-dollar',
    submenuItems: [
      {
        label: 'Refund Management',
        submenu: false,
        showSubRoute: false,
        link: '/admin/refunds',
        icon: 'ti ti-currency-dollar',
        roles: ['admin'],
      },
      {
        label: 'Ticket Sales',
        submenu: false,
        showSubRoute: false,
        link: '/admin/ticket-dashboard',
        icon: 'ti ti-ticket',
        roles: ['admin'],
      },
      {
        label: 'Payment Configuration',
        submenu: false,
        showSubRoute: false,
        link: '/admin/payment-configuration',
        icon: 'ti ti-credit-card-pay',
        roles: ['admin'],
      },
    ],
  },
  {
    label: 'Marketing',
    submenuOpen: false,
    showSubRoute: false,
    submenuHdr: 'Marketing',
    icon: 'ti ti-chart-bar',
    submenuItems: [
      {
        label: 'Advertisements',
        icon: 'ti ti-ad',
        submenu: false,
        showSubRoute: false,
        link: '/admin/advertisements',
        roles: ['admin'],
      },
      {
        label: 'Marketing Dashboard',
        icon: 'ti ti-chart-bar',
        submenu: false,
        showSubRoute: false,
        link: '/admin/marketing',
        roles: ['admin'],
      },
    ],
  },
  {
    label: 'FAQ',
    submenuHdr: 'FAQ',
    icon: 'ti ti-question-mark',
    link: routes.faq,
  },
];
